export default __webpack_public_path__ + "static/media/Snd_ClowerV.5e5ef2bd.mp3";